import React from 'react';
import DataProvider from '../../DataProvider.js'
import useUser from '../../hooks/useUser'
import { Edit, SimpleForm, TextInput, BooleanInput, useRedirect } from 'react-admin';
import validateContact from '../../validators/ContactValidate'
import EditConfirmToolbar from '../../components/EditConfirmToolbar'
import { parse } from "query-string";
import OrgSelector from '../../components/OrgSelector';
import ContactOptInCheckBox from '../../components/ContactOptInCheckbox'

const ContactEdit = (props) => {
    const user = useUser()
    const showOrgSelector = user.role === 'super-admin' || (user.Organizations && user.Organizations.length > 1)
    const alertM = `Warning, this cannot be undone. This org will be deleted permanently.`

    const { organization_id } = parse(props.location.search);

    const redirectTo = useRedirect();

    const uploadData = async (data) => {
        const cL = await DataProvider.update('contacts', { id: data.id, data: { ...data }, })
        redirectTo(`/contacts/${cL.data.id}/show?organization_id=${organization_id}`, cL)
    }
    return (<Edit {...props} title="Edit Contact">
        <SimpleForm toolbar={<EditConfirmToolbar handlesave={uploadData} tbredirect='/contacts' alertmessage={alertM} dataprovidersource='contacts' history={props.history} />} validate={validateContact}>
            <OrgSelector fullWidth source="org_id"  {...props} locked={organization_id} required />
            {!showOrgSelector && user.Organizations && <TextInput source='org_id' initialValue={user.Organizations[0].id} style={{ display: 'none' }} />}
            <TextInput fullWidth label="First Name" source="firstName" />
            <TextInput fullWidth label="Last Name" source="lastName" />
            <TextInput fullWidth label="Email" source="email" />
            <TextInput fullWidth label="Phone Number" source="phone" />
            
            <BooleanInput required label="" source="optIn"/>
            <ContactOptInCheckBox />
        </SimpleForm>
    </Edit>)
}

export default ContactEdit